import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getAirportCargoTerminalList(params) {
  return request({
    url: URL.mdm.basicData.airportCargoTerminal,
    method: 'get',
    params
  })
}

export function saveAirportCargoTerminal(data) {
  return request({
    url: URL.mdm.basicData.airportCargoTerminal,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delAirportCargoTerminal(uuid) {
  return request({
    url: URL.mdm.basicData.airportCargoTerminal + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
